module.exports = __webpack_public_path__ + "img/Robinson.18c97c0c.jpg";